import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/btn_close.png'
import _imports_1 from '@/assets/images/loading.gif'


const _hoisted_1 = { class: "download-content display-y-center display-s-b" }
const _hoisted_2 = { class: "user-disbale-content" }
const _hoisted_3 = { class: "mask-bg item-center" }

import CheckDebug from '@/components/common/CheckDebug.vue';
import TipDefault from '@/components/popup/TipDefault.vue';
import Iframe from "@/components/common/Iframe.vue"
import Header from '@/components/common/Header.vue'
import Navbar from '@/components/common/Navbar.vue'
import NewPlayerTip from '@/components/popup/NewPlayerTip.vue'
import { getLinkParams } from '@/utils/function';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { onBeforeMount, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { LOCAL_STORE, USER_TYPE } from './config/constConfig';
import NewPlayerTips from './views/activitys/cashBack/tip/NewPlayerTips.vue';
import CashBackTip from './components/popup/CashBackTip.vue';
import Alert from './components/popup/Alert.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

onBeforeMount(() => {
    initUrlParams();
});

onMounted(() => {
    checkLogin();
});

const initUrlParams = () => {
    const params = getLinkParams();
    store.state.code = params.get("code");
};

function onClosePWA() {
    store.state.isShowPWA = false;
    localStorage.setItem(LOCAL_STORE.IS_DOWN_PWA, "1");
}

/**是否显示提示界面 */
function isCanShowCashBackTip(): boolean {
    if (store.state.userType == USER_TYPE.A && store.state.isShowCashBackTip 
        && (store.state.accountInfo.vipLevel == 0 || store.state.accountInfo.withdrawNum == 1)) {
        return true;
    }
    return false;
}

function onDownload() {
    store.state.deferredPrompt.prompt(); // 触发安装提示
    store.state.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        localStorage.setItem(LOCAL_STORE.IS_DOWN_PWA, "1");
      } else {
        console.log('User dismissed the A2HS prompt')
      }
      store.state.deferredPrompt = null; // 重置事件对象
    });
}

/**检测是否登录*/
function checkLogin() {
    if (store.state.isLogin != 1) {
        router.push('/');
    } else {
        let isShow = localStorage.getItem(LOCAL_STORE.IS_SHOW_NEWPLAYER);
        if (isShow != "1") {
            store.state.isShowNewPlayer = true;
        }
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "close",
        src: _imports_0,
        onClick: onClosePWA
      })
    ], 512), [
      [_vShow, _unref(store).state.isShowPWA]
    ]),
    (_unref(route).meta.showHeader)
      ? (_openBlock(), _createBlock(Header, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_unref(route).meta.showNavbar)
      ? (_openBlock(), _createBlock(Navbar, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(CheckDebug),
    (_unref(store).state.gameUrl)
      ? (_openBlock(), _createBlock(Iframe, {
          key: 2,
          href: _unref(store).state.gameUrl,
          newStyle: 'display: block !important;'
        }, null, 8, ["href"]))
      : _createCommentVNode("", true),
    (_unref(store).state.isShowNewPlayer)
      ? (_openBlock(), _createBlock(NewPlayerTip, {
          key: 3,
          onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).state.isShowNewPlayer = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(Alert),
    (_unref(store).state.isShowCashBackProp)
      ? (_openBlock(), _createBlock(NewPlayerTips, { key: 4 }))
      : _createCommentVNode("", true),
    _createVNode(CashBackTip, {
      visible: isCanShowCashBackTip()
    }, null, 8, ["visible"]),
    (_unref(store).state.isUserDisbale)
      ? (_openBlock(), _createBlock(TipDefault, {
          key: 5,
          title: _unref(t)('common.1'),
          isShowClose: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("common.22")), 1)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_3, _cache[1] || (_cache[1] = [
      _createElementVNode("img", {
        src: _imports_1,
        class: "item-center"
      }, null, -1)
    ]), 512), [
      [_vShow, _unref(store).state.isShowMaskBg]
    ])
  ], 64))
}
}

})